module.exports = __webpack_public_path__ + "img/introduce_title.f8046727.png";